

export default {

    getList(pm, extra = {}) {
        if(pm && pm.type && pm.gateway_name) {
          switch (pm.gateway_name) {
            case 'EBANX':
                if (pm.type === 'card') // convert to switch if more cases is required
                    return this.getEbanxList(extra)
                break;
            case 'DLOCAL': 
                if (pm.type === 'card') 
                    return this.dlocal_document_list;
                break;
            }
        }
        return [];
    },

    getEbanxList({ countryCode }) {
        if(countryCode) {
            return this.ebanx_document_list.filter(e => e.countries.includes(countryCode))
        } else {
            return this.ebanx_document_list;
        }
    },

    ebanx_document_list: [
        {
            display_name: "CDI",
            value: "cdi",
            countries: ["AR"]
        },
        {
            display_name: "CUIL",
            value: "cuil",
            countries: ["AR"]
        },
        {
            display_name: "CUIT",
            value: "cuit",
            countries: ["AR"]
        },
        {
            display_name: "DNI",
            value: "dni",
            countries: ["AR"]
        },
        {
            display_name: "CPF",
            value: "cpf",
            countries: ["BR"]
        },
        {
            display_name: "CNPJ",
            value: "cnpj",
            countries: ["BR"]
        },
        {
            display_name: "RUT",
            value: "rut",
            countries: ["CL"]
        },
        {
            display_name: "CC",
            value: "cc",
            countries: ["CO"]
        },
        {
            display_name: "CE",
            value: "ce",
            countries: ["CO"]
        },
        {
            display_name: "NIT",
            value: "nit",
            countries: ["CO"]
        },
        {
            display_name: "DOC",
            value: "doc",
            countries: ["EC", "PE"]
        },
        {
            display_name: "CI",
            value: "ci",
            countries: ["UY"]
        },
        
    ],

    //Added in alphabetical order
    dlocal_document_list: [
        {
            display_name: "Argentina - DNI",
            value: "ar_dni",
            country_code : "AR"
        },
        {
            display_name: "Argentina - CUIT",
            value: "ar_cuit",
            country_code : "AR"
        },
        // {
        //     display_name: "Bangladesh - National Identify Card",
        //     value: "bd_nic",
        //     country_code : "BD"
        // },
        // {
        //     display_name: "Bangladesh - NID Card",
        //     value: "bd_nid",
        //     country_code : "BD"
        // },
        // {
        //     display_name: "Bolivia - CI",
        //     value: "bo_ci",
        //     country_code : "BO"
        // },
        {
            display_name: "Brazil - CPF",
            value: "br_cpf",
            country_code : "BR" //Brazil
        },
        {
            display_name: "Brazil - CNPJ",
            value: "br_cnpj",
            country_code : "BR" //Brazil
        },
        // {
        //     display_name: "Cameroon - CNI",
        //     value: "cm_cni",
        //     country_code : "CM" //Cameroon
        // },
        // {
        //     display_name: "Cameroon - ID",
        //     value: "cm_id",
        //     country_code : "CM" //Cameroon
        // },
        {
            display_name: "Chile - CI",
            value: "cl_ci",
            country_code : "CL" 
        },
        {
            display_name: "Chile - RUT",
            value: "cl_rut",
            country_code : "CL" 
        },
        // {
        //     display_name: "China - Citizen ID number",
        //     value: "cn_cidn",
        //     country_code : "CM" 
        // }, 
        {
            display_name: "Colombia - CC",
            value: "co_cc",
            country_code : "CO" 
        },
        // {
        //     display_name: "Costa Rica - CI",
        //     value: "cr_ci",
        //     country_code : "CR" 
        // },
        // {
        //     display_name: "Dominican Republic - ID",
        //     value: "do_id",
        //     country_code : "DO" 
        // },    
        // {
        //     display_name: "Ecuador - CI",
        //     value: "ec_ci",
        //     country_code : "EC" 
        // },
        // {
        //     display_name: "El Salvador - DUI",
        //     value: "sv_dui",
        //     country_code : "SV" 
        // },
        // {
        //     display_name: "Egypt - ID",
        //     value: "eg_id",
        //     country_code : "EG" 
        // },
        // {
        //     display_name: "Ghana - Ghana Card",
        //     value: "gh_gc",
        //     country_code : "GH" 
        // },
        // {
        //     display_name: "Guatemala - CUI",
        //     value: "gt_cui",
        //     country_code : "GT" 
        // },
        // {
        //     display_name: "Honduras - DNI",
        //     value: "hn_dni",
        //     country_code : "HN" 
        // },
        {
            display_name: "India - PAN",
            value: "in_pan",
            country_code : "IN" 
        },
        // {
        //     display_name: "Indonesia - NIK",
        //     value: "id_nik",
        //     country_code : "ID" 
        // },
        // {
        //     display_name: "Ivory Coast - National Identify Card (CNI)",
        //     value: "ci_cni",
        //     country_code : "CI" 
        // },
        // {
        //     display_name: "Japan - National identification number",
        //     value: "jp_nin",
        //     country_code : "JP" 
        // },
        // {
        //     display_name: "Kenya - National ID Card",
        //     value: "ke_nic",
        //     country_code : "KE" 
        // },
        // {
        //     display_name: "Malaysia - NRIC",
        //     value: "my_nric",
        //     country_code : "MY" 
        // },
        {
            display_name: "Mexico - CURP",
            value: "mx_curp",
            country_code : "MX" 
        },
        // {
        //     display_name: "Morocco - CNIE",
        //     value: "ma_cnie",
        //     country_code : "MA" 
        // },
        // {
        //     display_name: "Nicaragua - DNI",
        //     value: "ni_dni",
        //     country_code : "NI" 
        // },
        // {
        //     display_name: "Nigeria - NIN",
        //     value: "ng_nin",
        //     country_code : "NG" 
        // },
        // {
        //     display_name: "Pakistan - CNIC",
        //     value: "pk_cnic",
        //     country_code : "PK" 
        // },
        // {
        //     display_name: "Panama - Cedula de Identidad",
        //     value: "pa_cdi",
        //     country_code : "PA" 
        // },
        // {
        //     display_name: "Paraguay - CI",
        //     value: "py_ci",
        //     country_code : "PY" 
        // },
        {
            display_name: "Peru - DNI",
            value: "pe_dni",
            country_code : "PE" 
        },
        // {
        //     display_name: "Philippines - PSN",
        //     value: "ph_psn",
        //     country_code : "PH" 
        // },
        // {
        //     display_name: "Rwanda - National Identity Card",
        //     value: "rw_nic",
        //     country_code : "RW" 
        // },
        // {
        //     display_name: "Senegal - CNI",
        //     value: "sn_cni",
        //     country_code : "SN" 
        // },
        // {
        //     display_name: "Senegal - ECOWAS ID Card",
        //     value: "sn_ecowas",
        //     country_code : "SN" 
        // },
        // {
        //     display_name: "South Africa - South African Identity Card",
        //     value: "sa_saic",
        //     country_code : "ZA" 
        // },
        // {
        //     display_name: "Tanzania - National Identity Card",
        //     value: "tz_nic",
        //     country_code : "TZ" 
        // },
        // {
        //     display_name: "Thailand - Thai Identity Card",
        //     value: "th_tic",
        //     country_code : "TH" 
        // },
        // {
        //     display_name: "Turkey - T.C. Kimlik No.",
        //     value: "tr_tckn",
        //     country_code : "TR" 
        // },
        // {
        //     display_name: "Uganda - Ndaga Muntu - National ID number (NIC)",
        //     value: "ug_nic",
        //     country_code : "UG" 
        // },
        // {
        //     display_name: "Uruguay - CI",
        //     value: "uy_ci",
        //     country_code : "UY" 
        // },
        // {
        //     display_name: "Uruguay - RUT",
        //     value: "uy_rut",
        //     country_code : "UY" 
        // },
        // {
        //     display_name: "Vietnam - VNID",
        //     value: "vn_vnid",
        //     country_code : "VN" 
        // },
        // {
        //     display_name: "Zambia - National Registration Card",
        //     value: "zm_nrc",
        //     country_code : "ZM" 
        // }
    ]
}
